import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ToolsIndex from "@/pages/ToolsIndex";

export const Route = createFileRoute("/tools/")({
  head: () => seoHead("/tools/"),
  component: ToolsIndex,
});
